import { AbstractCourse } from '../api/types/settings/studies/abstract-course';
import { makeAutoObservable } from 'mobx';
import { Major } from '../api/types/settings/studies/major';
import { SupervisoryInstitution } from '../api/types/settings/studies/supervisory-institution';
import { AbstractProgram } from '../api/types/settings/studies/abstract-program';
import { AssignmentType } from '../api/types/settings/studies/assignment-type';
import { ExamType } from '../api/types/settings/studies/exam-type';
import appApi from '../api/app-api';
import globalSettingsBranches from './global-settings-branches';
import { SettingsDocsType } from '../api/types/settings/docs/settings-docs-type';
import { SettingsServicePaymentType } from '../api/types/settings/payments/settings-service-payment-type';
import { SettingsLecturersRateType } from '../api/types/settings/lecturers/settings-lecturers-rate-type';
import globalConfigStore from './global-config-store';
import { ScholarshipFundersEntities } from '../api/types/settings/scholarship-funders';
import {
  PollWithQuestionsResponse,
  SettingsAll,
} from '../api/types/settings/settings-all';
import { CourseStudentStatus } from '../api/types/settings/studies/course-student-status';
import {
  SettingsMappingUsersRolesToDocWithDocNameEntity,
  SettingsUserRoleDocCreatedDefault,
} from '../api/types/settings/user-document-created-default/settings-user-role-doc-created-default';
import { SettingsCheckStatusPaymentServiceEntity } from '../api/types/settings/check-status-payment-service/check-status-payment-service';
import { AbstractExternalExam } from '../api/types/settings/studies/abstract-external-exam';

class SettingsStores {
  abstractProgram: AbstractProgram[] = [];
  // TODO loading from payment-services...
  abstractCourses: AbstractCourse[] = [];
  private _supervisoryInstitution: SupervisoryInstitution[] = [];
  private _majors: Major[] = [];

  assignmentTypes: AssignmentType[] = [];

  examTypes: ExamType[] = [];

  externalExams: AbstractExternalExam[] = [];

  docTypes: SettingsDocsType[] = [];
  userDefaultDocumentCreation: SettingsMappingUsersRolesToDocWithDocNameEntity[] =
    [];

  lecturersTypeRateNames: SettingsLecturersRateType[] = [];

  servicePaymentTypes: SettingsServicePaymentType[] = [];
  checkPaymentStatus: SettingsCheckStatusPaymentServiceEntity[] = [];

  scholarshipFunders: ScholarshipFundersEntities[] = [];

  courseStudentStatuses: CourseStudentStatus[] = [];

  abstractPolls: PollWithQuestionsResponse[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  async fetchSetting(dataResRef?: SettingsAll) {
    let dataRes: SettingsAll;
    let res: any; // Declare res variable

    if (!dataResRef) {
      res = await appApi.getAllSettings();
      dataRes = res.data.body;
    } else {
      dataRes = dataResRef;
    }

    console.log(`Settings $$$: ${JSON.stringify(res)}`);
    //const dataRes = res.data.body;
    this.courseStudentStatuses = dataRes.education.courseStudentStatuses;
    this.majors = dataRes.education.majors;
    this.abstractCourses = dataRes.education.courses;
    this.examTypes = dataRes.education.exams;
    this.externalExams = dataRes.education.externalExams;
    this.docTypes = dataRes.docTypes;
    this.userDefaultDocumentCreation = dataRes.userDefaultDocumentCreation;
    this.assignmentTypes = dataRes.education.assignments;
    this.supervisoryInstitution = dataRes.education.supervisoryInstitutions;
    this.abstractProgram = dataRes.education.programs;
    this.scholarshipFunders = dataRes.scholarshipFunders;

    this.servicePaymentTypes = dataRes.paymentTypes;
    this.checkPaymentStatus = dataRes.checkPaymentStatus;

    this.lecturersTypeRateNames = dataRes.lecturersTypeRateNames;

    this.abstractPolls = dataRes.abstractPolls || [];

    globalSettingsBranches.workingTimeManagement =
      dataRes.workingTimeManagement;

    globalSettingsBranches.classAttributes = dataRes.classAttributes;
    globalSettingsBranches.classAttributes2 = dataRes.classAttributes2;

    /*    // Function to generate dummy classes with attributes based on global settings
    function addDummyClassesToBuildings(
      buildings: Building[],
      globalClassAttributeLists: ClassAttributeList[],
    ): Building[] {
      return buildings.map((building) => {
        // Generate 2-4 dummy classes per building
        const numClasses = Math.floor(Math.random() * 3) + 2;
        const dummyClasses: ClassMetadata[] = [];

        for (let i = 0; i < numClasses; i++) {
          // Create class attributes based on global settings
          const classAttributeValues: ClassAttributeListValues[] =
            globalClassAttributeLists.map((attrList) => {
              // Create a copy of the attribute list with dummy values
              const attributesWithValues: ClassAttributeValueEntity[] =
                attrList.attributes.map((attr) => {
                  // Create dummy values based on attribute type
                  return {
                    ...attr,
                    numericValue:
                      attr.attributeType === 'numeric'
                        ? Math.floor(Math.random() * 100)
                        : undefined,
                    boolValue:
                      attr.attributeType === 'boolean'
                        ? Math.random() > 0.5
                        : undefined,
                  };
                });

              return {
                listId: attrList.listId,
                listName: attrList.listName,
                attributes: attributesWithValues,
              };
            });

          // Create the dummy class
          const dummyClass: ClassMetadata = {
            id: building.id * 100 + i,
            className: `Class ${building.buildingName}-${i + 1}`,
            attributes: classAttributeValues,
            createdAt: new Date(),
            createdBy: 1,
            createdByName: 'System',
          };

          dummyClasses.push(dummyClass);
        }

        // Return building with dummy classes
        return {
          ...building,
          classes: dummyClasses,
        };
      });
    }

    // Usage example:
    const buildingsWithDummyClasses = addDummyClassesToBuildings(
      dataRes.buildings,
      globalSettingsBranches.classAttributes2,
    );*/

    //globalSettingsBranches.buildings = dataRes.buildings;
    //globalSettingsBranches.buildings = buildingsWithDummyClasses;
    globalSettingsBranches.buildings = dataRes.buildings;
    globalSettingsBranches.branches = dataRes.branches;
    if (globalSettingsBranches.branches.length > 0) {
      globalConfigStore.rootFilter.currentBranches =
        globalSettingsBranches.branches[0];
    }
  }

  setAbstractCourses(courses: AbstractCourse[]) {
    this.abstractCourses = courses;
  }

  addAbstractCourse(course: AbstractCourse) {
    this.abstractCourses.push(course);
  }

  get supervisoryInstitution(): SupervisoryInstitution[] {
    return this._supervisoryInstitution;
  }

  set supervisoryInstitution(value: SupervisoryInstitution[]) {
    this._supervisoryInstitution = value;
  }

  get majors(): Major[] {
    return this._majors;
  }

  set majors(value: Major[]) {
    this._majors = value;
  }
}
const globalSettingsStores = new SettingsStores();
export default globalSettingsStores;
